// Claves de traducción adicionales (lote 3) — se fusionan con translations.js
export const translationsExtra = {
  ES: {
    // Apartado técnicos
    'footer.technicians': 'Apartado técnicos',
    'technicians.title': 'Apartado técnicos',
    'technicians.subtitle': 'Acceso restringido para el equipo técnico de SmartPOS.',
    'technicians.email': 'Email',
    'technicians.password': 'Contraseña',
    'technicians.login': 'Iniciar sesión',
    'technicians.loggingIn': 'Iniciando sesión...',
    'technicians.google': 'Continuar con Google',
    'technicians.invalid': 'Credenciales no válidas. Revísalas e inténtalo de nuevo.',
    'technicians.welcome': 'Hola',
    'technicians.accessTitle': 'Configurador de hardware',
    'technicians.accessDesc': 'Accede al configurador de PC para montar equipos a medida para tus clientes.',
    'technicians.openConfig': 'Abrir el configurador',
    'technicians.logout': 'Cerrar sesión',
    'technicians.noPermission': 'Sin permisos',
    'technicians.noPermissionDesc': 'Esta cuenta no tiene acceso al apartado técnicos.',
    // Página Sobre nosotros
    'about.eyebrow': 'Sobre SmartPOS',
    'about.title1': 'Quiénes',
    'about.title2': 'Somos',
    'about.desc1': 'En SmartPOS desarrollamos soluciones tecnológicas que ayudan a los negocios a digitalizar, simplificar y optimizar su gestión.',
    'about.desc2': 'Combinamos innovación, tecnología y servicio personalizado para ofrecer soluciones adaptadas a las necesidades de cada cliente.',
    'about.mission.title': 'Misión',
    'about.mission.claim': 'Simplificar la gestión. Potenciar Negocios.',
    'about.mission.text': 'Ofrecer soluciones tecnológicas innovadoras, sencillas y adaptadas que ayuden a nuestros clientes a gestionar sus negocios de forma más eficiente, conectada y rentable.',
    'about.vision.title': 'Visión',
    'about.vision.claim': 'Transformar la forma de hacer negocios.',
    'about.vision.text': 'Ser un referente en soluciones tecnológicas para negocios, impulsando su transformación digital y acompañándolos en un entorno cada vez más conectado y dinámico.',
    'about.values.title': 'Valores',
    'about.values.subtitle': 'Los principios que guían nuestro trabajo cada día.',
    'about.values.innovation.title': 'Innovación',
    'about.values.innovation.text': 'Miramos hacia adelante para convertir la tecnología en oportunidades reales. Investigamos y adoptamos las últimas tendencias, como la inteligencia artificial, para crear soluciones que marquen la diferencia.',
    'about.values.commitment.title': 'Compromiso',
    'about.values.commitment.text': 'Nos implicamos en cada proyecto y en cada relación con nuestros clientes. Acompañamos cada implementación de principio a fin, con dedicación y responsabilidad en cada detalle.',
    'about.values.closeness.title': 'Cercanía',
    'about.values.closeness.text': 'Detrás de cada negocio hay personas. Escuchamos, entendemos y acompañamos a nuestros clientes en cada etapa, construyendo relaciones de confianza y cercanas.',
    'about.values.adaptability.title': 'Adaptabilidad',
    'about.values.adaptability.text': 'Cada negocio es único. Nuestras soluciones también deben serlo. Configuramos cada implementación a medida para que se ajuste a las necesidades específicas de cada sector.',
    'about.values.evolution.title': 'Evolución',
    'about.values.evolution.text': 'Aprendemos, mejoramos y avanzamos continuamente para ofrecer siempre más. Incorporamos nuevas tecnologías y funcionalidades de forma constante para que nuestros clientes crezcan sin límites.',
    'about.cta.title': '¿Hablamos de tu negocio?',
    'about.cta.text': 'Descubre cómo nuestras soluciones pueden ayudarte a crecer. Sin compromiso.',
    'about.cta.demo': 'Pedir demo',
    'about.cta.contact': 'Contactar',

    // Textos compartidos de secciones
    'faq.sectionTitle': 'Preguntas frecuentes',
    'indicator.inicio': 'Inicio',
    'indicator.sectores': 'Sectores',
    'indicator.comoFunciona': 'Cómo funciona',
    'indicator.solucion': 'La solución',
    'indicator.verifactu': 'VeriFactu',
    'indicator.tpv': 'TPV para negocio',
    'indicator.faq': 'Preguntas frecuentes',
    'ia.chart.title': 'Predicción de demanda semanal',
    'ia.chart.subtitle': 'IA analizando ventas reales vs. predicción',
    'ia.chart.real': 'Real',
    'ia.chart.prediction': 'Predicción IA',
    'aria.clientCarousel': 'Carrusel de clientes de SmartPOS',
    'aria.playVideo': 'Reproducir video',
    'aria.mute': 'Activar sonido',
    'aria.unmute': 'Desactivar sonido',
    'aria.fullscreen': 'Pantalla completa',
    'ia.day.lun': 'Lun',
    'ia.day.mar': 'Mar',
    'ia.day.mie': 'Mié',
    'ia.day.jue': 'Jue',
    'ia.day.vie': 'Vie',
    'ia.day.sab': 'Sáb',
    'ia.day.dom': 'Dom',
    'ia.chart.insight': 'El sábado superará el viernes un 15%. Prepara 40 raciones extra y refuerza personal a las 14:30.',

    // Manifesto (Home)
    'home.manifesto1.title': 'El futuro del negocio físico ya no depende de la tecnología. Depende de cómo la conectamos.',
    'home.manifesto2.eyebrow': 'La solución',
    'home.manifesto2.title': 'Smartpos transforma tu negocio al 100%. Unimos IA, TPV, ERP, CRM, eCommerce, automatización y datos en un único ecosistema inteligente.',
    'home.manifesto3.eyebrow': 'El resultado',
    'home.manifesto3.title': 'Con Smartpos, los negocios reducen costes, aumentan ventas, automatizan procesos y toman decisiones con precisión quirúrgica.',

    // Sectors section
    'sectors.eyebrow': 'Sectores',
    'sectors.title1': 'Adaptado a tu',
    'sectors.titleHighlight': 'tipo de negocio',
    'sectors.desc': 'No existe una solución única. Nuestro sistema se configura para las necesidades exactas de tu sector.',
    'sectors.hospitality.name': 'Hostelería',
    'sectors.hospitality.headline': 'Más mesas servidas, menos esperas.',
    'sectors.hospitality.desc': 'Desde restaurantes hasta discotecas. Pedidos por mesa, carta digital, cocina conectada y cierre de caja automático.',
    'sectors.hospitality.tags': 'Restaurantes|Bares|Fast Food|Disco / Pub|Heladerías',
    'sectors.hospitality.metric': '30% más rápido en el servicio',
    'sectors.retail.name': 'Retail',
    'sectors.retail.headline': 'Vende más. Gestiona menos.',
    'sectors.retail.desc': 'Control de stock en tiempo real, fidelización de clientes y ventas omnicanal desde un único panel.',
    'sectors.retail.tags': 'Tiendas de ropa|Zapaterías|Accesorios|Supermercados|Comercios',
    'sectors.retail.metric': '25% reducción en tiempos de caja',
    'sectors.food.name': 'Alimentación',
    'sectors.food.headline': 'Precisión en cada gramo.',
    'sectors.food.desc': 'Integración con básculas, gestión de mermas, trazabilidad por lote y cumplimiento normativo automático.',
    'sectors.food.tags': 'Panaderías|Pastelerías|Carnicerías|Fruterías|Colmados',
    'sectors.food.metric': '40% menos errores en stock',
    'sectors.beauty.name': 'Belleza',
    'sectors.beauty.headline': 'Tu agenda llena, tu caja ordenada.',
    'sectors.beauty.desc': 'Reservas online 24/7, gestión de citas, seguimiento de comisiones y carta de servicios digital.',
    'sectors.beauty.tags': 'Peluquerías|Centros de estética|Spa|Nail Studio|Barbería',
    'sectors.beauty.metric': '60% más reservas online',
    'sectors.metricLabel': 'Media de clientes SmartPOS en este sector',
    'sectors.demo': 'Solicitar demo',
    'sectors.prices': 'Ver precios',

    // IA section
    'ia.eyebrow': 'IA Implantada',
    'ia.title1': 'Inteligencia artificial',
    'ia.title2': 'implantada en tu negocio.',
    'ia.desc': 'No se trata de añadir IA, sino de implantarla donde de verdad transforma: dentro de tu TPV, tu inventario y tus decisiones. SmartPOS convierte tus datos operativos en inteligencia accionable.',
    'ia.live': '● en vivo',
    'ia.subtitle': 'Restaurante La Rambla · servicio de comida',
    'ia.quote': 'Vamos un 18,85% por encima del objetivo. Refuerza el turno de cocina a las 14:30 y prepara 40 raciones más de menú del día.',
    'ia.kpi.sales': 'Ventas de hoy',
    'ia.kpi.forecast': 'Predicción mañana',
    'ia.kpi.ticket': 'Ticket medio',
    'ia.kpi.peak': 'Hora punta prevista',
    'ia.kpi.vsTarget': '+18,8% vs objetivo',
    'ia.kpi.vsToday': '+12% vs hoy',
    'ia.kpi.desserts': '+€1,90 postres',
    'ia.kpi.capacity': '+34% aforo',
    'ia.starDish': 'Plato estrella hoy',
    'ia.starDishDemand': '+34% demanda',
    'ia.starDishName': 'Paella de marisco',
    'ia.starDishRec': 'Sube el precio €1,50: la demanda lo aguanta. Margen estimado +€38/día.',
    'ia.alertStock': 'Stock crítico: gamba, limón y cerveza artesana',
    'ia.alertWaste': 'Merma prevista: 6 postres caducan en 48h — lanza 2x1',

    // Verifactu section
    'verifactu.eyebrow': 'VeriFactu',
    'verifactu.title': 'Cumplimiento fiscal automático',
    'verifactu.desc': 'Firma y envío automático de tickets a la Agencia Tributaria, sin cambiar tu forma de trabajar.',
    'verifactu.f1': 'Firma electrónica automática en cada ticket',
    'verifactu.f2': 'Envío en tiempo real a la Agencia Tributaria',
    'verifactu.f3': 'Cumple la normativa en toda España',
    'verifactu.f4': 'Actualizaciones de normativa incluidas',
    'verifactu.f5': 'Sin cambios en tu flujo de trabajo habitual',
    'verifactu.viewSolution': 'Ver solución completa',
    'verifactu.startNow': 'Empezar ahora',
    'verifactu.monitor': 'VeriFactu Monitor',
    'verifactu.systemActive': 'Sistema activo',
    'verifactu.live': 'EN VIVO',
    'verifactu.compliant': '100% compliant con normativa española',
    'verifactu.log1': 'Ticket #4521 firmado',
    'verifactu.log2': 'Enviado a AEAT',
    'verifactu.log3': 'Ticket #4520 firmado',
    'verifactu.log4': 'Enviado a AEAT',
    'verifactu.log5': 'Arqueo de caja registrado',

    // SEO content section
    'seo.eyebrow': 'TPV para negocio',
    'seo.title1': 'El',
    'seo.titleHighlight': 'TPV para tu negocio',
    'seo.titleEnd': ', todo integrado',
    'seo.desc': 'Software TPV en la nube, hardware, cajones inteligentes, quioscos, carta digital y pagos. Un ecosistema para vender más.',
    'seo.whatTitle': '¿Qué es un TPV y por qué lo necesita tu negocio?',
    'seo.whatText': 'Un TPV (Terminal Punto de Venta) gestiona las ventas de tu negocio: cobro, stock, informes, empleados y multi-tienda. Un buen sistema TPV automatiza y analiza para crecer. SmartPOS incluye software TPV en la nube, hardware táctil, cajones CashDro, quioscos de autoservicio, carta digital y pedidos online y medios de pago integrados.',
    'seo.typesTitle': 'TPV para cada tipo de negocio',
    'seo.type1.label': 'TPV para hostelería y restaurantes',
    'seo.type1.desc': 'Mesas, comandas, cocina, carta digital y pedidos online.',
    'seo.type2.label': 'TPV para retail y tiendas',
    'seo.type2.desc': 'Stock, códigos de barras, proveedores y márgenes en tiempo real.',
    'seo.type3.label': 'TPV para alimentación',
    'seo.type3.desc': 'Peso, lotes, caducidades y sincronización multi-sucursal.',
    'seo.type4.label': 'TPV para belleza y peluquerías',
    'seo.type4.desc': 'Agenda, citas, abonos y comisiones por empleado.',
    'seo.whyTitle': '¿Por qué elegir SmartPOS como tu TPV?',
    'seo.reason1': 'Todo integrado: software, hardware, pagos, quioscos y carta digital',
    'seo.reason2': 'Cumplimiento VeriFactu preparado para 2027',
    'seo.reason3': 'Multi-tienda: gestiona todas tus tiendas desde un único panel',
    'seo.reason4': 'Respuesta en menos de 24h con equipo local en Barcelona y Madrid',
    'seo.reason5': 'Funciona sin internet con sincronización automática',
    'seo.reason6': 'Demo gratis y sin compromiso',
    'seo.cta': 'Probar TPV gratis',

    // Results testimonials

    // FAQ
    'faq.eyebrow': 'Preguntas Frecuentes',
    'faq.title1': 'Resolvemos tus',
    'faq.titleHighlight': 'dudas',
    'faq.desc': 'Todo lo que necesitas saber antes de dar el paso',
    'faq.ctaDesc': '¿No encuentras respuesta a tu pregunta?',
    'faq.ctaBtn': 'Habla con un experto',
    'faq.cat.install': 'Instalación',
    'faq.cat.support': 'Soporte técnico',
    'faq.cat.verifactu': 'VeriFactu',
    'faq.cat.integration': 'Integración',
    'faq.q1': '¿Cuánto tarda la instalación del sistema?',
    'faq.a1': 'La instalación de HIOPOS Cloud es rápida y sencilla. En la mayoría de los casos, tu negocio estará operativo en menos de 24 horas. Nuestro equipo técnico se encarga de configurar el software, el hardware táctil y los dispositivos de pago para que solo tengas que empezar a vender.',
    'faq.q2': '¿Necesito cambiar todo mi hardware actual?',
    'faq.a2': 'No. HIOPOS Cloud funciona en múltiples dispositivos: TPV táctil, tablets, smartphones e incluso tu hardware compatible actual. Evaluamos tu equipamiento y te recomendamos la solución más rentable, sin cambiar lo que ya te funciona.',
    'faq.q3': '¿En cuánto tiempo responde el soporte técnico?',
    'faq.a3': 'Contestamos en menos de 24 horas. Puedes contactarnos por teléfono, email o chat en directo y nuestro equipo de soporte técnico te responde a la mayor brevedad posible, con resolución de incidencias garantizada.',
    'faq.q4': '¿Qué pasa si se cae la conexión a internet?',
    'faq.a4': 'El sistema sigue funcionando. HIOPOS Cloud es un TPV híbrido que opera con o sin conexión: registra todas las ventas localmente y se sincroniza automáticamente con la nube cuando se restablece la conexión, sin perder ni un solo dato.',
    'faq.q5': '¿El sistema está adaptado a la normativa VeriFactu?',
    'faq.a5': 'Sí. HIOPOS Cloud cumple totalmente con la normativa VeriFactu, obligatoria antes del 1 de enero de 2027. El sistema genera y envía automáticamente las facturas simplificadas a la AEAT, sin que tengas que hacer nada manualmente.',
    'faq.q6': '¿Tengo que hacer algo para cumplir con Hacienda?',
    'faq.a6': 'No. La integración con VeriFactu es automática y transparente. Cada vez que emites un ticket, el sistema lo registra, firma y envía a Hacienda por ti. Solo tienes que vender; nosotros nos encargamos del cumplimiento fiscal.',
    'faq.q7': '¿Puedo integrar el TPV con mi ecommerce y pedidos online?',
    'faq.a7': 'Por supuesto. El ecosistema SmartPOS es omnicanal: integra TPV, carta digital, pedidos online, delivery, takeaway y reservas en un único sistema. Todo sincronizado en tiempo real, con el stock y las ventas centralizados.',
    'faq.q8': '¿Funciona con varios establecimientos?',
    'faq.a8': 'Sí. HIOPOS Cloud es multiestablecimiento y multiterminal. Gestiona todas tus tiendas desde un único panel, con el stock, las ventas y los informes consolidados en tiempo real, sin importar cuántos establecimientos tengas.',

    // Trust section
    'trust.eyebrow': 'Casos de Éxito',
    'trust.title1': 'Ellos ya',
    'trust.titleHighlight': 'crecieron',
    'trust.titleEnd': 'con HIOPOS',
    'trust.desc': '+500 negocios en España confían en las soluciones HIOPOS',
    'trust.stat1': 'Negocios activos',
    'trust.stat2': 'Transacciones gestionadas',
    'trust.stat3': 'Uptime del sistema',
    'trust.stat4': 'Valoración media',
    'trust.logoStrip': 'NEGOCIOS Y ENTIDADES QUE CONFÍAN EN LAS SOLUCIONES HIOPOS',

    // Success carousel
    'success.label': 'Casos de éxito · +500 negocios confían en las soluciones HIOPOS',

    // Chat widget
    'chat.greeting': '¡Hola! 👋 Soy Smarty!, el asistente virtual de Smartpos. Cuéntame de qué es tu negocio y te ayudo a encontrar la solución ideal. ¿En qué sector operas?',
    'chat.name': 'Smarty',
    'chat.online': 'En línea',
    'chat.mute': 'Silenciar voz',
    'chat.unmute': 'Activar voz',
    'chat.placeholder': 'Escribe tu mensaje...',
    'chat.assistant': 'Asistente IA de SmartPOS',
    'chat.suggestion1': '¿Qué solución es ideal para un restaurante?',
    'chat.suggestion2': '¿Cómo funciona el CashDro?',
    'chat.suggestion3': '¿Qué incluye la demo gratuita?',
    'chat.errorReply': 'Lo siento, no he podido responder ahora. ¿Puedes reformular?',
    'chat.errorTech': 'Vaya, ha habido un problema técnico. Puedes llamarnos al +34 936 302 521 o solicitar la demo gratuita.',

    // Demo page
    'demo.step': 'Paso',
    'demo.of': 'de',
    'demo.progressLabel': 'Progreso del formulario',
    'demo.s0Title': '¿En qué sector operas?',
    'demo.s0Subtitle': 'Empezamos por conocernos',
    'demo.s1Title': '¿Cuántos establecimientos tienes?',
    'demo.s1Subtitle': 'Adaptamos la solución a tu tamaño',
    'demo.s2Title': '¿Qué necesitas?',
    'demo.s2Subtitle': 'Elige todo lo que te interese',
    'demo.s3Title': 'Un experto te llama hoy',
    'demo.s3Subtitle': 'Sin compromiso · Respuesta en menos de 24h laborables',
    'demo.name': 'Nombre',
    'demo.namePlaceholder': 'Tu nombre',
    'demo.phone': 'Teléfono *',
    'demo.phonePlaceholder': '+34 600 000 000',
    'demo.email': 'Email',
    'demo.emailPlaceholder': 'tu@empresa.com',
    'demo.company': 'Empresa / Local',
    'demo.companyPlaceholder': 'Nombre del negocio',
    'demo.province': 'Provincia',
    'demo.provincePlaceholder': 'Barcelona, Madrid...',
    'demo.notes': 'Observaciones',
    'demo.notesPlaceholder': 'Cuéntanos lo que necesitas (opcional)',
    'demo.back': 'Atrás',
    'demo.continue': 'Continuar',
    'demo.submit': 'Quiero mi demo',
    'demo.submitting': 'Enviando...',
    'demo.reassurance1': 'RGPD',
    'demo.reassurance2': 'Respuesta 24h laborables',
    'demo.reassurance3': '100% gratis',
    'demo.successTitle1': '¡Perfecto,',
    'demo.successTitle2': '!',
    'demo.successDesc1': 'Un experto te llamará al',
    'demo.successDesc2': 'en menos de 24h laborables.',
    'demo.successItem1': 'Demo personalizada',
    'demo.successItem2': 'Precio a medida',
    'demo.successItem3': 'Sin compromiso',
    'demo.successCall': '¿Prefieres llamar?',
    'demo.backHome': 'Volver al inicio',
    'demo.errorDuplicate': 'Ya hemos recibido tu solicitud. Un experto te contactará muy pronto.',
    'demo.errorGeneric': 'No se pudo enviar. Inténtalo de nuevo o llámanos al 936 302 521.',

    // Local SEO page
    'local.coverage': 'Cobertura en',
    'local.requestDemo': 'Solicitar demo gratuita',
    'local.whyTitle': 'Por qué elegir SmartPOS en',
    'local.benefit1Title': 'Instalación en 24h',
    'local.benefit1Desc': 'Tu negocio operativo en menos de 24 horas con configuración incluida.',
    'local.benefit2Title': 'Respuesta en menos de 24h',
    'local.benefit2Desc': 'Atención técnica local todos los días del año, contestamos en menos de 24 horas.',
    'local.benefit3Title': 'Cumple VeriFactu',
    'local.benefit3Desc': 'Facturas simplificadas enviadas automáticamente a la AEAT.',
    'local.benefit4Title': 'Multi-establecimiento',
    'local.benefit4Desc': 'Gestiona todas tus tiendas de la zona desde un único panel.',
    'local.benefit5Title': 'Funciona offline',
    'local.benefit5Desc': 'Vende con o sin internet; se sincroniza al volver la conexión.',
    'local.benefit6Title': 'Cobertura local',
    'local.benefit6Desc': 'Equipo técnico en tu provincia para instalación y mantenimiento.',
    'local.sectorsTitle': 'Sectores que cubrimos en',
    'local.sector1': 'Hostelería y restaurantes',
    'local.sector2': 'Retail y moda',
    'local.sector3': 'Alimentación',
    'local.sector4': 'Belleza y peluquerías',
    'local.zonesTitle': 'Zonas de instalación',
    'local.zonesDesc1': '¿No ves tu zona? Cubrimos toda la provincia de',
    'local.zonesDesc2': 'y alrededores. Llámanos y te confirmamos disponibilidad.',
    'local.ctaTitle1': '¿Hablamos de tu negocio en',
    'local.ctaTitle2': '?',
    'local.ctaSubtitle': 'Solicita tu demo gratuita y un experto local te llama.',
    'local.ctaBtn': 'Solicitar demo',

    // Aviso de cookies
    'cookie.text': 'Usamos cookies para analizar el tráfico.',
    'cookie.accept': 'Aceptar',
    'cookie.policy': 'Política de cookies',
  },
    // Avisos de error — formularios y carga de datos
    'form.required': 'Este campo es obligatorio',
    'form.email': 'Revisa el email: parece incompleto',
    'form.phone': 'Escribe un teléfono válido (mínimo 7 dígitos)',
    'form.notes': 'Máximo 1000 caracteres',
    'data.loadError': 'No hemos podido cargar esto.',
    'data.retry': 'Reintentar',
  EN: {
    // Technicians area
    'footer.technicians': 'Technicians',
    'technicians.title': 'Technicians area',
    'technicians.subtitle': 'Restricted access for the SmartPOS technical team.',
    'technicians.email': 'Email',
    'technicians.password': 'Password',
    'technicians.login': 'Log in',
    'technicians.loggingIn': 'Logging in...',
    'technicians.google': 'Continue with Google',
    'technicians.invalid': 'Invalid credentials. Please check and try again.',
    'technicians.welcome': 'Hi',
    'technicians.accessTitle': 'Hardware configurator',
    'technicians.accessDesc': 'Access the PC builder to assemble custom equipment for your clients.',
    'technicians.openConfig': 'Open the configurator',
    'technicians.logout': 'Log out',
    'technicians.noPermission': 'No access',
    'technicians.noPermissionDesc': 'This account does not have access to the technicians area.',
    // About page
    'about.eyebrow': 'About SmartPOS',
    'about.title1': 'Who',
    'about.title2': 'We Are',
    'about.desc1': 'At SmartPOS we develop technology solutions that help businesses digitalise, simplify and optimise their management.',
    'about.desc2': "We combine innovation, technology and personalised service to deliver solutions tailored to each client's needs.",
    'about.mission.title': 'Mission',
    'about.mission.claim': 'Simplify management. Empower businesses.',
    'about.mission.text': 'To offer innovative, simple and tailored technology solutions that help our clients manage their businesses more efficiently, connectedly and profitably.',
    'about.vision.title': 'Vision',
    'about.vision.claim': 'Transform the way business is done.',
    'about.vision.text': 'To be a benchmark in technology solutions for businesses, driving their digital transformation and supporting them in an increasingly connected and dynamic environment.',
    'about.values.title': 'Values',
    'about.values.subtitle': 'The principles that guide our work every day.',
    'about.values.innovation.title': 'Innovation',
    'about.values.innovation.text': 'We look ahead to turn technology into real opportunities. We research and adopt the latest trends, such as artificial intelligence, to create solutions that make a difference.',
    'about.values.commitment.title': 'Commitment',
    'about.values.commitment.text': 'We get involved in every project and every relationship with our clients. We support each implementation from start to finish, with dedication and responsibility in every detail.',
    'about.values.closeness.title': 'Closeness',
    'about.values.closeness.text': 'Behind every business there are people. We listen, understand and support our clients at every stage, building trusted, close relationships.',
    'about.values.adaptability.title': 'Adaptability',
    'about.values.adaptability.text': 'Every business is unique. Our solutions must be too. We configure each implementation to fit the specific needs of each sector.',
    'about.values.evolution.title': 'Evolution',
    'about.values.evolution.text': 'We learn, improve and move forward continuously to always offer more. We constantly add new technologies and features so our clients can grow without limits.',
    'about.cta.title': 'Shall we talk about your business?',
    'about.cta.text': 'Discover how our solutions can help you grow. No obligation.',
    'about.cta.demo': 'Request a demo',
    'about.cta.contact': 'Get in touch',

    // Shared section text
    'faq.sectionTitle': 'Frequently asked questions',
    'indicator.inicio': 'Home',
    'indicator.sectores': 'Sectors',
    'indicator.comoFunciona': 'How it works',
    'indicator.solucion': 'The solution',
    'indicator.verifactu': 'VeriFactu',
    'indicator.tpv': 'POS for business',
    'indicator.faq': 'FAQ',
    'ia.chart.title': 'Weekly demand forecast',
    'ia.chart.subtitle': 'AI analysing actual sales vs. forecast',
    'ia.chart.real': 'Actual',
    'ia.chart.prediction': 'AI forecast',
    'aria.clientCarousel': 'SmartPOS client carousel',
    'aria.playVideo': 'Play video',
    'aria.mute': 'Turn sound on',
    'aria.unmute': 'Turn sound off',
    'aria.fullscreen': 'Full screen',
    'ia.day.lun': 'Mon',
    'ia.day.mar': 'Tue',
    'ia.day.mie': 'Wed',
    'ia.day.jue': 'Thu',
    'ia.day.vie': 'Fri',
    'ia.day.sab': 'Sat',
    'ia.day.dom': 'Sun',
    'ia.chart.insight': 'Saturday will beat Friday by 15%. Prepare 40 extra portions and add staff at 2:30 pm.',

    'home.manifesto1.title': "The future of the physical business no longer depends on technology. It depends on how we connect it.",
    'home.manifesto2.eyebrow': 'The solution',
    'home.manifesto2.title': 'Smartpos transforms your business 100%. We unite AI, POS, ERP, CRM, eCommerce, automation and data in a single intelligent ecosystem.',
    'home.manifesto3.eyebrow': 'The result',
    'home.manifesto3.title': 'With Smartpos, businesses reduce costs, increase sales, automate processes and make decisions with surgical precision.',

    'sectors.eyebrow': 'Sectors',
    'sectors.title1': 'Adapted to your',
    'sectors.titleHighlight': 'type of business',
    'sectors.desc': 'There is no one-size-fits-all solution. Our system configures to the exact needs of your sector.',
    'sectors.hospitality.name': 'Hospitality',
    'sectors.hospitality.headline': 'More tables served, less waiting.',
    'sectors.hospitality.desc': 'From restaurants to nightclubs. Table orders, digital menu, connected kitchen and automatic cash closing.',
    'sectors.hospitality.tags': 'Restaurants|Bars|Fast Food|Disco / Pub|Ice cream shops',
    'sectors.hospitality.metric': '30% faster service',
    'sectors.retail.name': 'Retail',
    'sectors.retail.headline': 'Sell more. Manage less.',
    'sectors.retail.desc': 'Real-time stock control, customer loyalty and omnichannel sales from a single panel.',
    'sectors.retail.tags': 'Clothing stores|Shoe shops|Accessories|Supermarkets|Shops',
    'sectors.retail.metric': '25% reduction in checkout times',
    'sectors.food.name': 'Food',
    'sectors.food.headline': 'Precision in every gram.',
    'sectors.food.desc': 'Scale integration, waste management, batch traceability and automatic regulatory compliance.',
    'sectors.food.tags': 'Bakeries|Pastry shops|Butcher shops|Fruit shops|Grocery stores',
    'sectors.food.metric': '40% fewer stock errors',
    'sectors.beauty.name': 'Beauty',
    'sectors.beauty.headline': 'Your agenda full, your cash organized.',
    'sectors.beauty.desc': '24/7 online bookings, appointment management, commission tracking and digital service menu.',
    'sectors.beauty.tags': 'Hair salons|Beauty centers|Spa|Nail Studio|Barbershop',
    'sectors.beauty.metric': '60% more online bookings',
    'sectors.metricLabel': 'Average of SmartPOS clients in this sector',
    'sectors.demo': 'Request demo',
    'sectors.prices': 'See prices',

    'ia.eyebrow': 'Embedded AI',
    'ia.title1': 'Artificial intelligence',
    'ia.title2': 'embedded in your business.',
    'ia.desc': "It's not about adding AI, but embedding it where it truly transforms: inside your POS, your inventory and your decisions. SmartPOS turns your operational data into actionable intelligence.",
    'ia.live': '● live',
    'ia.subtitle': 'Restaurante La Rambla · lunch service',
    'ia.quote': 'We are 18.85% above target. Reinforce the kitchen shift at 14:30 and prepare 40 more daily menu portions.',
    'ia.kpi.sales': "Today's sales",
    'ia.kpi.forecast': "Tomorrow's forecast",
    'ia.kpi.ticket': 'Average ticket',
    'ia.kpi.peak': 'Expected peak hour',
    'ia.kpi.vsTarget': '+18.8% vs target',
    'ia.kpi.vsToday': '+12% vs today',
    'ia.kpi.desserts': '+€1.90 desserts',
    'ia.kpi.capacity': '+34% capacity',
    'ia.starDish': "Today's star dish",
    'ia.starDishDemand': '+34% demand',
    'ia.starDishName': 'Seafood paella',
    'ia.starDishRec': 'Raise the price €1.50: demand holds. Estimated margin +€38/day.',
    'ia.alertStock': 'Critical stock: prawn, lemon and craft beer',
    'ia.alertWaste': 'Expected waste: 6 desserts expire in 48h — launch 2x1',

    'verifactu.eyebrow': 'VeriFactu',
    'verifactu.title': 'Automatic tax compliance',
    'verifactu.desc': 'Automatic signing and sending of receipts to the Tax Agency, without changing how you work.',
    'verifactu.f1': 'Automatic electronic signature on every receipt',
    'verifactu.f2': 'Real-time sending to the Tax Agency',
    'verifactu.f3': 'Compliant with regulations across Spain',
    'verifactu.f4': 'Regulatory updates included',
    'verifactu.f5': 'No changes to your usual workflow',
    'verifactu.viewSolution': 'See full solution',
    'verifactu.startNow': 'Start now',
    'verifactu.monitor': 'VeriFactu Monitor',
    'verifactu.systemActive': 'System active',
    'verifactu.live': 'LIVE',
    'verifactu.compliant': '100% compliant with Spanish regulations',
    'verifactu.log1': 'Receipt #4521 signed',
    'verifactu.log2': 'Sent to AEAT',
    'verifactu.log3': 'Receipt #4520 signed',
    'verifactu.log4': 'Sent to AEAT',
    'verifactu.log5': 'Cash register recorded',

    'seo.eyebrow': 'POS for business',
    'seo.title1': 'The',
    'seo.titleHighlight': 'POS for your business',
    'seo.titleEnd': ', all integrated',
    'seo.desc': 'Cloud POS software, hardware, smart drawers, kiosks, digital menu and payments. An ecosystem to sell more.',
    'seo.whatTitle': 'What is a POS and why does your business need one?',
    'seo.whatText': 'A POS (Point of Sale Terminal) manages your business sales: checkout, stock, reports, staff and multi-store. A good POS system automates and analyzes to grow. SmartPOS includes cloud POS software, touch hardware, CashDro drawers, self-service kiosks, digital menu and online orders and integrated payment methods.',
    'seo.typesTitle': 'POS for every type of business',
    'seo.type1.label': 'POS for hospitality and restaurants',
    'seo.type1.desc': 'Tables, orders, kitchen, digital menu and online orders.',
    'seo.type2.label': 'POS for retail and shops',
    'seo.type2.desc': 'Stock, barcodes, suppliers and real-time margins.',
    'seo.type3.label': 'POS for food',
    'seo.type3.desc': 'Weight, batches, expiry dates and multi-branch sync.',
    'seo.type4.label': 'POS for beauty and hair salons',
    'seo.type4.desc': 'Agenda, appointments, passes and per-employee commissions.',
    'seo.whyTitle': 'Why choose SmartPOS as your POS?',
    'seo.reason1': 'All integrated: software, hardware, payments, kiosks and digital menu',
    'seo.reason2': 'VeriFactu compliance ready for 2027',
    'seo.reason3': 'Multi-store: manage all your stores from a single panel',
    'seo.reason4': 'Response in less than 24h with local team in Barcelona and Madrid',
    'seo.reason5': 'Works without internet with automatic synchronization',
    'seo.reason6': 'Free demo with no obligation',
    'seo.cta': 'Try POS free',


    'faq.eyebrow': 'Frequently Asked Questions',
    'faq.title1': 'We solve your',
    'faq.titleHighlight': 'doubts',
    'faq.desc': 'Everything you need to know before taking the step',
    'faq.ctaDesc': "Can't find the answer to your question?",
    'faq.ctaBtn': 'Talk to an expert',
    'faq.cat.install': 'Installation',
    'faq.cat.support': 'Technical support',
    'faq.cat.verifactu': 'VeriFactu',
    'faq.cat.integration': 'Integration',
    'faq.q1': 'How long does the system installation take?',
    'faq.a1': 'Installing HIOPOS Cloud is fast and simple. In most cases, your business will be operational in less than 24 hours. Our technical team configures the software, touch hardware and payment devices so you only have to start selling.',
    'faq.q2': 'Do I need to change all my current hardware?',
    'faq.a2': 'No. HIOPOS Cloud works on multiple devices: touch POS, tablets, smartphones and even your current compatible hardware. We assess your equipment and recommend the most cost-effective solution, without changing what already works for you.',
    'faq.q3': 'How quickly does technical support respond?',
    'faq.a3': 'We reply in less than 24 hours. You can contact us by phone, email or live chat and our technical support team responds as soon as possible, with guaranteed incident resolution.',
    'faq.q4': 'What happens if the internet connection drops?',
    'faq.a4': 'The system keeps working. HIOPOS Cloud is a hybrid POS that operates with or without connection: it records all sales locally and automatically syncs with the cloud when the connection is restored, without losing a single piece of data.',
    'faq.q5': 'Is the system adapted to the VeriFactu regulation?',
    'faq.a5': 'Yes. HIOPOS Cloud fully complies with the VeriFactu regulation, mandatory before January 1, 2027. The system automatically generates and sends simplified invoices to the AEAT, without you having to do anything manually.',
    'faq.q6': 'Do I have to do anything to comply with the tax authority?',
    'faq.a6': 'No. The VeriFactu integration is automatic and transparent. Every time you issue a receipt, the system registers, signs and sends it to the tax authority for you. You just have to sell; we handle tax compliance.',
    'faq.q7': 'Can I integrate the POS with my ecommerce and online orders?',
    'faq.a7': 'Of course. The SmartPOS ecosystem is omnichannel: it integrates POS, digital menu, online orders, delivery, takeaway and reservations in a single system. Everything synced in real time, with stock and sales centralized.',
    'faq.q8': 'Does it work with multiple locations?',
    'faq.a8': 'Yes. HIOPOS Cloud is multi-location and multi-terminal. Manage all your stores from a single panel, with stock, sales and reports consolidated in real time, no matter how many locations you have.',

    'trust.eyebrow': 'Success Stories',
    'trust.title1': 'They already',
    'trust.titleHighlight': 'grew',
    'trust.titleEnd': 'with HIOPOS',
    'trust.desc': '+500 businesses in Spain trust HIOPOS solutions',
    'trust.stat1': 'Active businesses',
    'trust.stat2': 'Transactions managed',
    'trust.stat3': 'System uptime',
    'trust.stat4': 'Average rating',
    'trust.logoStrip': 'BUSINESSES AND ENTITIES THAT TRUST HIOPOS SOLUTIONS',

    'success.label': 'Success stories · +500 businesses trust HIOPOS solutions',

    'chat.greeting': "Hi! 👋 I'm Smarty!, the Smartpos virtual assistant. Tell me about your business and I'll help you find the ideal solution. What sector do you operate in?",
    'chat.name': 'Smarty',
    'chat.online': 'Online',
    'chat.mute': 'Mute voice',
    'chat.unmute': 'Enable voice',
    'chat.placeholder': 'Type your message...',
    'chat.assistant': 'SmartPOS AI Assistant',
    'chat.suggestion1': 'Which solution is ideal for a restaurant?',
    'chat.suggestion2': 'How does CashDro work?',
    'chat.suggestion3': 'What does the free demo include?',
    'chat.errorReply': "Sorry, I couldn't answer right now. Can you rephrase?",
    'chat.errorTech': 'Oops, there was a technical problem. You can call us at +34 936 302 521 or request the free demo.',

    'demo.step': 'Step',
    'demo.of': 'of',
    'demo.progressLabel': 'Form progress',
    'demo.s0Title': 'What sector do you operate in?',
    'demo.s0Subtitle': "Let's start by getting to know each other",
    'demo.s1Title': 'How many locations do you have?',
    'demo.s1Subtitle': 'We adapt the solution to your size',
    'demo.s2Title': 'What do you need?',
    'demo.s2Subtitle': 'Choose everything that interests you',
    'demo.s3Title': 'An expert calls you today',
    'demo.s3Subtitle': 'No obligation · Response in less than 24 business hours',
    'demo.name': 'Name',
    'demo.namePlaceholder': 'Your name',
    'demo.phone': 'Phone *',
    'demo.phonePlaceholder': '+34 600 000 000',
    'demo.email': 'Email',
    'demo.emailPlaceholder': 'your@company.com',
    'demo.company': 'Company / Business',
    'demo.companyPlaceholder': 'Business name',
    'demo.province': 'Province',
    'demo.provincePlaceholder': 'Barcelona, Madrid...',
    'demo.notes': 'Notes',
    'demo.notesPlaceholder': 'Tell us what you need (optional)',
    'demo.back': 'Back',
    'demo.continue': 'Continue',
    'demo.submit': 'I want my demo',
    'demo.submitting': 'Sending...',
    'demo.reassurance1': 'GDPR',
    'demo.reassurance2': 'Response 24 business hours',
    'demo.reassurance3': '100% free',
    'demo.successTitle1': 'Perfect,',
    'demo.successTitle2': '!',
    'demo.successDesc1': 'An expert will call you at',
    'demo.successDesc2': 'in less than 24 business hours.',
    'demo.successItem1': 'Personalized demo',
    'demo.successItem2': 'Custom price',
    'demo.successItem3': 'No obligation',
    'demo.successCall': 'Prefer to call?',
    'demo.backHome': 'Back to home',
    'demo.errorDuplicate': 'We have already received your request. An expert will contact you very soon.',
    'demo.errorGeneric': 'Could not send. Please try again or call us at 936 302 521.',

    'local.coverage': 'Coverage in',
    'local.requestDemo': 'Request free demo',
    'local.whyTitle': 'Why choose SmartPOS in',
    'local.benefit1Title': '24h installation',
    'local.benefit1Desc': 'Your business operational in less than 24 hours with setup included.',
    'local.benefit2Title': 'Response in less than 24h',
    'local.benefit2Desc': 'Local technical support every day of the year, we reply in less than 24 hours.',
    'local.benefit3Title': 'VeriFactu compliant',
    'local.benefit3Desc': 'Simplified invoices sent automatically to the AEAT.',
    'local.benefit4Title': 'Multi-location',
    'local.benefit4Desc': 'Manage all your stores in the area from a single panel.',
    'local.benefit5Title': 'Works offline',
    'local.benefit5Desc': 'Sell with or without internet; syncs when the connection returns.',
    'local.benefit6Title': 'Local coverage',
    'local.benefit6Desc': 'Technical team in your province for installation and maintenance.',
    'local.sectorsTitle': 'Sectors we cover in',
    'local.sector1': 'Hospitality and restaurants',
    'local.sector2': 'Retail and fashion',
    'local.sector3': 'Food',
    'local.sector4': 'Beauty and hair salons',
    'local.zonesTitle': 'Installation areas',
    'local.zonesDesc1': "Don't see your area? We cover the entire province of",
    'local.zonesDesc2': 'and surroundings. Call us and we confirm availability.',
    'local.ctaTitle1': "Let's talk about your business in",
    'local.ctaTitle2': '?',
    'local.ctaSubtitle': 'Request your free demo and a local expert calls you.',
    'local.ctaBtn': 'Request demo',

    'cookie.text': 'We use cookies to analyse traffic.',
    'cookie.accept': 'Accept',
    'cookie.policy': 'Cookie policy',
  },
    'form.required': 'This field is required',
    'form.email': 'Check the email address — it looks incomplete',
    'form.phone': 'Enter a valid phone number (at least 7 digits)',
    'form.notes': 'Maximum 1000 characters',
    'data.loadError': "We couldn't load this.",
    'data.retry': 'Try again',
  CA: {
    // Apartat tècnics
    'footer.technicians': 'Apartat tècnics',
    'technicians.title': 'Apartat tècnics',
    'technicians.subtitle': "Accés restringit per a l'equip tècnic de SmartPOS.",
    'technicians.email': 'Correu electrònic',
    'technicians.password': 'Contrasenya',
    'technicians.login': 'Inicia sessió',
    'technicians.loggingIn': 'Iniciant sessió...',
    'technicians.google': 'Continuar amb Google',
    'technicians.invalid': 'Credencials no vàlides. Revisa-les i torna a intentar-ho.',
    'technicians.welcome': 'Hola',
    'technicians.accessTitle': 'Configurador de maquinari',
    'technicians.accessDesc': "Accedeix al configurador de PC per muntar equips a mida per als teus clients.",
    'technicians.openConfig': 'Obrir el configurador',
    'technicians.logout': 'Tanca la sessió',
    'technicians.noPermission': 'Sense permisos',
    'technicians.noPermissionDesc': "Aquest compte no té accés a l'apartat tècnic.",
    // Pàgina Qui som
    'about.eyebrow': 'Sobre SmartPOS',
    'about.title1': 'Qui',
    'about.title2': 'Som',
    'about.desc1': 'A SmartPOS desenvolupem solucions tecnològiques que ajuden els negocis a digitalitzar, simplificar i optimitzar la seva gestió.',
    'about.desc2': 'Combinem innovació, tecnologia i servei personalitzat per oferir solucions adaptades a les necessitats de cada client.',
    'about.mission.title': 'Missió',
    'about.mission.claim': 'Simplificar la gestió. Potenciar negocis.',
    'about.mission.text': 'Oferir solucions tecnològiques innovadores, senzilles i adaptades que ajudin els nostres clients a gestionar els seus negocis de manera més eficient, connectada i rendible.',
    'about.vision.title': 'Visió',
    'about.vision.claim': 'Transformar la manera de fer negocis.',
    'about.vision.text': 'Ser un referent en solucions tecnològiques per a negocis, impulsant la seva transformació digital i acompanyant-los en un entorn cada cop més connectat i dinàmic.',
    'about.values.title': 'Valors',
    'about.values.subtitle': 'Els principis que guien la nostra feina cada dia.',
    'about.values.innovation.title': 'Innovació',
    'about.values.innovation.text': 'Mirem endavant per convertir la tecnologia en oportunitats reals. Investiguem i adoptem les últimes tendències, com la intel·ligència artificial, per crear solucions que marquin la diferència.',
    'about.values.commitment.title': 'Compromís',
    'about.values.commitment.text': 'Ens impliquem en cada projecte i en cada relació amb els nostres clients. Acompanyem cada implementació de principi a fi, amb dedicació i responsabilitat en cada detall.',
    'about.values.closeness.title': 'Proximitat',
    'about.values.closeness.text': 'Darrere de cada negoci hi ha persones. Escoltem, entenem i acompanyem els nostres clients en cada etapa, construint relacions de confiança i properes.',
    'about.values.adaptability.title': 'Adaptabilitat',
    'about.values.adaptability.text': 'Cada negoci és únic. Les nostres solucions també ho han de ser. Configurem cada implementació a mida perquè s\'ajusti a les necessitats específiques de cada sector.',
    'about.values.evolution.title': 'Evolució',
    'about.values.evolution.text': 'Aprenem, millorem i avancem contínuament per oferir sempre més. Incorporem noves tecnologies i funcionalitats de manera constant perquè els nostres clients creixin sense límits.',
    'about.cta.title': 'Parlem del teu negoci?',
    'about.cta.text': 'Descobreix com les nostres solucions et poden ajudar a créixer. Sense compromís.',
    'about.cta.demo': 'Demanar demo',
    'about.cta.contact': 'Contactar',

    // Textos compartits de seccions
    'faq.sectionTitle': 'Preguntes freqüents',
    'indicator.inicio': 'Inici',
    'indicator.sectores': 'Sectors',
    'indicator.comoFunciona': 'Com funciona',
    'indicator.solucion': 'La solució',
    'indicator.verifactu': 'VeriFactu',
    'indicator.tpv': 'TPV per a negoci',
    'indicator.faq': 'Preguntes freqüents',
    'ia.chart.title': 'Predicció de demanda setmanal',
    'ia.chart.subtitle': 'IA analitzant vendes reals vs. predicció',
    'ia.chart.real': 'Real',
    'ia.chart.prediction': 'Predicció IA',
    'aria.clientCarousel': 'Carrusel de clients de SmartPOS',
    'aria.playVideo': 'Reproduir vídeo',
    'aria.mute': 'Activar so',
    'aria.unmute': 'Desactivar so',
    'aria.fullscreen': 'Pantalla completa',
    'ia.day.lun': 'Dl',
    'ia.day.mar': 'Dt',
    'ia.day.mie': 'Dc',
    'ia.day.jue': 'Dj',
    'ia.day.vie': 'Dv',
    'ia.day.sab': 'Ds',
    'ia.day.dom': 'Dg',
    'ia.chart.insight': 'El dissabte superarà el divendres un 15%. Prepara 40 racions extra i reforça el personal a les 14:30.',

    'home.manifesto1.title': "El futur del negoci físic ja no depèn de la tecnologia. Depèn de com la connectem.",
    'home.manifesto2.eyebrow': 'La solució',
    'home.manifesto2.title': 'Smartpos transforma el teu negoci al 100%. Unim IA, TPV, ERP, CRM, eCommerce, automatització i dades en un únic ecosistema intel·ligent.',
    'home.manifesto3.eyebrow': 'El resultat',
    'home.manifesto3.title': 'Amb Smartpos, els negocis redueixen costos, augmenten vendes, automatitzen processos i prenen decisions amb precisió quirúrgica.',

    'sectors.eyebrow': 'Sectors',
    'sectors.title1': 'Adaptat al teu',
    'sectors.titleHighlight': 'tipus de negoci',
    'sectors.desc': "No existeix una solució única. El nostre sistema es configura per a les necessitats exactes del teu sector.",
    'sectors.hospitality.name': 'Hostaleria',
    'sectors.hospitality.headline': 'Més taules servides, menys esperes.',
    'sectors.hospitality.desc': "Des de restaurants fins a discoteques. Comandes per taula, carta digital, cuina connectada i tancament de caixa automàtic.",
    'sectors.hospitality.tags': 'Restaurants|Bars|Fast Food|Discoteca / Pub|Gelateries',
    'sectors.hospitality.metric': '30% més ràpid en el servei',
    'sectors.retail.name': 'Retail',
    'sectors.retail.headline': 'Ven més. Gestiona menys.',
    'sectors.retail.desc': "Control d'stock en temps real, fidelització de clients i vendes omnicanal des d'un únic panell.",
    'sectors.retail.tags': 'Botigues de roba|Sabateries|Accessoris|Supermercats|Comerços',
    'sectors.retail.metric': '25% reducció en temps de caixa',
    'sectors.food.name': 'Alimentació',
    'sectors.food.headline': 'Precisió en cada gram.',
    'sectors.food.desc': "Integració amb bàscules, gestió de mermes, traçabilitat per lot i compliment normatiu automàtic.",
    'sectors.food.tags': 'Fleques|Pastisseries|Carnisseries|Fruiteries|Colmados',
    'sectors.food.metric': '40% menys errors en stock',
    'sectors.beauty.name': 'Bellesa',
    'sectors.beauty.headline': 'La teva agenda plena, la teva caixa ordenada.',
    'sectors.beauty.desc': 'Reserves online 24/7, gestió de cites, seguiment de comissions i carta de servei digital.',
    'sectors.beauty.tags': "Perruqueries|Centres d'estètica|Spa|Nail Studio|Barberia",
    'sectors.beauty.metric': '60% més reserves online',
    'sectors.metricLabel': 'Mitjana de clients SmartPOS en aquest sector',
    'sectors.demo': 'Sol·licita demo',
    'sectors.prices': 'Veure preus',

    'ia.eyebrow': 'IA Implantada',
    'ia.title1': 'Intel·ligència artificial',
    'ia.title2': 'implantada al teu negoci.',
    'ia.desc': "No es tracta d'afegir IA, sinó d'implantar-la on de veritat transforma: dins del teu TPV, el teu inventari i les teves decisions. SmartPOS converteix les teves dades operatives en intel·ligència accionable.",
    'ia.live': '● en directe',
    'ia.subtitle': 'Restaurante La Rambla · servei de dinar',
    'ia.quote': "Anem un 18,85% per sobre de l'objectiu. Reforça el torn de cuina a les 14:30 i prepara 40 racions més de menú del dia.",
    'ia.kpi.sales': "Vendes d'avui",
    'ia.kpi.forecast': 'Predicció demà',
    'ia.kpi.ticket': 'Ticket mitjà',
    'ia.kpi.peak': 'Hora punta prevista',
    'ia.kpi.vsTarget': '+18,8% vs objectiu',
    'ia.kpi.vsToday': '+12% vs avui',
    'ia.kpi.desserts': '+€1,90 postres',
    'ia.kpi.capacity': '+34% aforament',
    'ia.starDish': 'Plat estrella avui',
    'ia.starDishDemand': '+34% demanda',
    'ia.starDishName': 'Paella de marisc',
    'ia.starDishRec': 'Puja el preu €1,50: la demanda ho aguanta. Marge estimat +€38/dia.',
    'ia.alertStock': 'Stock crític: gamba, llimona i cervesa artesana',
    'ia.alertWaste': 'Merma prevista: 6 postres caduquen en 48h — llança 2x1',

    'verifactu.eyebrow': 'VeriFactu',
    'verifactu.title': 'Cumpliment fiscal automàtic',
    'verifactu.desc': "Signatura i enviament automàtic de tiquets a l'Agència Tributària, sense canviar la teva forma de treballar.",
    'verifactu.f1': 'Signatura electrònica automàtica en cada tiquet',
    'verifactu.f2': "Enviament en temps real a l'Agència Tributària",
    'verifactu.f3': 'Compleix la normativa a tota Espanya',
    'verifactu.f4': 'Actualitzacions de normativa incloses',
    'verifactu.f5': 'Sense canvis al teu flux de treball habitual',
    'verifactu.viewSolution': 'Veure solució completa',
    'verifactu.startNow': 'Començar ara',
    'verifactu.monitor': 'VeriFactu Monitor',
    'verifactu.systemActive': 'Sistema actiu',
    'verifactu.live': 'EN DIRECTE',
    'verifactu.compliant': '100% compliant amb normativa espanyola',
    'verifactu.log1': 'Tiquet #4521 signat',
    'verifactu.log2': 'Enviat a AEAT',
    'verifactu.log3': 'Tiquet #4520 signat',
    'verifactu.log4': 'Enviat a AEAT',
    'verifactu.log5': 'Arqueig de caixa registrat',

    'seo.eyebrow': 'TPV per a negoci',
    'seo.title1': 'El',
    'seo.titleHighlight': 'TPV per al teu negoci',
    'seo.titleEnd': ', tot integrat',
    'seo.desc': 'Software TPV al núvol, hardware, calaixos intel·ligents, quioscos, carta digital i pagaments. Un ecosistema per vendre més.',
    'seo.whatTitle': 'Què és un TPV i per què el necessita el teu negoci?',
    'seo.whatText': "Un TPV (Terminal Punt de Venda) gestiona les vendes del teu negoci: cobrament, stock, informes, empleats i multi-botiga. Un bon sistema TPV automatitza i analitza per créixer. SmartPOS inclou software TPV al núvol, hardware tàctil, calaixos CashDro, quioscos d'autoservei, carta digital i comandes online i mitjans de pagament integrats.",
    'seo.typesTitle': 'TPV per a cada tipus de negoci',
    'seo.type1.label': 'TPV per a hostaleria i restaurants',
    'seo.type1.desc': 'Taules, comandes, cuina, carta digital i comandes online.',
    'seo.type2.label': 'TPV per a retail i botigues',
    'seo.type2.desc': 'Stock, codis de barres, proveïdors i marges en temps real.',
    'seo.type3.label': 'TPV per a alimentació',
    'seo.type3.desc': 'Pes, lots, caducitats i sincronització multi-sucursal.',
    'seo.type4.label': 'TPV per a bellesa i perruqueries',
    'seo.type4.desc': 'Agenda, cites, abonaments i comissions per empleat.',
    'seo.whyTitle': 'Per què triar SmartPOS com a TPV?',
    'seo.reason1': 'Tot integrat: software, hardware, pagaments, quioscos i carta digital',
    'seo.reason2': 'Cumpliment VeriFactu preparat per al 2027',
    'seo.reason3': "Multi-botiga: gestiona totes les teves botigues des d'un únic panell",
    'seo.reason4': 'Resposta en menys de 24h amb equip local a Barcelona i Madrid',
    'seo.reason5': 'Funciona sense internet amb sincronització automàtica',
    'seo.reason6': 'Demo gratis i sense compromís',
    'seo.cta': 'Provar TPV gratis',


    'faq.eyebrow': 'Preguntes Freqüents',
    'faq.title1': 'Resolem els teus',
    'faq.titleHighlight': 'dubtes',
    'faq.desc': 'Tot el que necessites saber abans de donar el pas',
    'faq.ctaDesc': 'No trobes resposta a la teva pregunta?',
    'faq.ctaBtn': 'Parla amb un expert',
    'faq.cat.install': 'Instal·lació',
    'faq.cat.support': 'Suport tècnic',
    'faq.cat.verifactu': 'VeriFactu',
    'faq.cat.integration': 'Integració',
    'faq.q1': 'Quant tarda la instal·lació del sistema?',
    'faq.a1': "La instal·lació de HIOPOS Cloud és ràpida i senzilla. En la majoria dels casos, el teu negoci estarà operatiu en menys de 24 hores. El nostre equip tècnic s'encarrega de configurar el software, l'hardware tàctil i els dispositius de pagament perquè només hagis de començar a vendre.",
    'faq.q2': 'Necessito canviar tot el meu hardware actual?',
    'faq.a2': "No. HIOPOS Cloud funciona en múltiples dispositius: TPV tàctil, tablets, smartphones i fins i tot el teu hardware compatible actual. Avaluem el teu equipament i et recomanem la solució més rendible, sense canviar el que ja et funciona.",
    'faq.q3': 'En quant temps respon el suport tècnic?',
    'faq.a3': "Contestem en menys de 24 hores. Pots contactar-nos per telèfon, email o xat en directe i el nostre equip de suport tècnic et respon a la major brevetat possible, amb resolució d'incidències garantida.",
    'faq.q4': 'Què passa si es cau la connexió a internet?',
    'faq.a4': "El sistema segueix funcionant. HIOPOS Cloud és un TPV híbrid que opera amb o sense connexió: registra totes les vendes localment i se sincronitza automàticament amb el núvol quan es restableix la connexió, sense perdre ni una sola dada.",
    'faq.q5': 'El sistema està adaptat a la normativa VeriFactu?',
    'faq.a5': "Sí. HIOPOS Cloud compleix totalment amb la normativa VeriFactu, obligatòria abans de l'1 de gener de 2027. El sistema genera i envia automàticament les factures simplificades a l'AEAT, sense que hagis de fer res manualment.",
    'faq.q6': 'He de fer alguna cosa per complir amb Hisenda?',
    'faq.a6': "No. La integració amb VeriFactu és automàtica i transparent. Cada vegada que emets un tiquet, el sistema el registra, signa i envia a Hisenda per tu. Només has de vendre; nosaltres ens encarreguem del compliment fiscal.",
    'faq.q7': 'Puc integrar el TPV amb el meu ecommerce i comandes online?',
    'faq.a7': "Per descomptat. L'ecosistema SmartPOS és omnicanal: integra TPV, carta digital, comandes online, delivery, takeaway i reserves en un únic sistema. Tot sincronitzat en temps real, amb l'stock i les vendes centralitzats.",
    'faq.q8': 'Funciona amb diversos establiments?',
    'faq.a8': "Sí. HIOPOS Cloud és multi-establiment i multiterminal. Gestiona totes les teves botigues des d'un únic panell, amb l'stock, les vendes i els informes consolidats en temps real, no importa quants establiments tinguis.",

    'trust.eyebrow': "Casos d'Èxit",
    'trust.title1': 'Ells ja',
    'trust.titleHighlight': 'han crescut',
    'trust.titleEnd': 'amb HIOPOS',
    'trust.desc': '+500 negocis a Espanya confien en les solucions HIOPOS',
    'trust.stat1': 'Negocis actius',
    'trust.stat2': 'Transaccions gestionades',
    'trust.stat3': 'Uptime del sistema',
    'trust.stat4': 'Valoració mitjana',
    'trust.logoStrip': 'NEGOCIS I ENTITATS QUE CONFIEN EN LES SOLUCIONS HIOPOS',

    'success.label': "Casos d'èxit · +500 negocis confien en les solucions HIOPOS",

    'chat.greeting': "Hola! 👋 Sóc Smarty!, l'assistent virtual de Smartpos. Explica'm de què és el teu negoci i t'ajudo a trobar la solució ideal. En quin sector operes?",
    'chat.name': 'Smarty',
    'chat.online': 'En línia',
    'chat.mute': 'Silenciar veu',
    'chat.unmute': 'Activar veu',
    'chat.placeholder': 'Escriu el teu missatge...',
    'chat.assistant': 'Assistent IA de SmartPOS',
    'chat.suggestion1': 'Quina solució és ideal per a un restaurant?',
    'chat.suggestion2': 'Com funciona el CashDro?',
    'chat.suggestion3': 'Què inclou la demo gratuïta?',
    'chat.errorReply': 'Ho sento, no he pogut respondre ara. Pots reformular?',
    'chat.errorTech': "Ui, hi ha hagut un problema tècnic. Pots trucar-nos al +34 936 302 521 o sol·licitar la demo gratuïta.",

    'demo.step': 'Pas',
    'demo.of': 'de',
    'demo.progressLabel': 'Progrés del formulari',
    'demo.s0Title': 'En quin sector operes?',
    'demo.s0Subtitle': 'Comencem per conèixer-nos',
    'demo.s1Title': 'Quants establiments tens?',
    'demo.s1Subtitle': 'Adaptem la solució a la teva mida',
    'demo.s2Title': 'Què necessites?',
    'demo.s2Subtitle': "Tria tot el que t'interessi",
    'demo.s3Title': 'Un expert et truca avui',
    'demo.s3Subtitle': 'Sense compromís · Resposta en menys de 24h laborables',
    'demo.name': 'Nom',
    'demo.namePlaceholder': 'El teu nom',
    'demo.phone': 'Telèfon *',
    'demo.phonePlaceholder': '+34 600 000 000',
    'demo.email': 'Email',
    'demo.emailPlaceholder': 'tu@empresa.com',
    'demo.company': 'Empresa / Local',
    'demo.companyPlaceholder': 'Nom del negoci',
    'demo.province': 'Província',
    'demo.provincePlaceholder': 'Barcelona, Madrid...',
    'demo.notes': 'Observacions',
    'demo.notesPlaceholder': 'Explica\'ns el que necessites (opcional)',
    'demo.back': 'Enrere',
    'demo.continue': 'Continuar',
    'demo.submit': 'Vull la meva demo',
    'demo.submitting': 'Enviant...',
    'demo.reassurance1': 'RGPD',
    'demo.reassurance2': 'Resposta 24h laborables',
    'demo.reassurance3': '100% gratis',
    'demo.successTitle1': 'Perfecte,',
    'demo.successTitle2': '!',
    'demo.successDesc1': 'Un expert et trucarà al',
    'demo.successDesc2': 'en menys de 24h laborables.',
    'demo.successItem1': 'Demo personalitzada',
    'demo.successItem2': 'Preu a mida',
    'demo.successItem3': 'Sense compromís',
    'demo.successCall': 'Prefereixes trucar?',
    'demo.backHome': "Tornar a l'inici",
    'demo.errorDuplicate': 'Ja hem rebut la teva sol·licitud. Un expert et contactarà molt aviat.',
    'demo.errorGeneric': "No s'ha pogut enviar. Torna-ho a provar o truca'ns al 936 302 521.",

    'local.coverage': 'Cobertura a',
    'local.requestDemo': 'Sol·licita demo gratuïta',
    'local.whyTitle': 'Per què triar SmartPOS a',
    'local.benefit1Title': 'Instal·lació en 24h',
    'local.benefit1Desc': 'El teu negoci operatiu en menys de 24 hores amb configuració inclosa.',
    'local.benefit2Title': 'Resposta en menys de 24h',
    'local.benefit2Desc': 'Atenció tècnica local tots els dies de l\'any, contestem en menys de 24 hores.',
    'local.benefit3Title': 'Cumpleix VeriFactu',
    'local.benefit3Desc': 'Factures simplificades enviades automàticament a l\'AEAT.',
    'local.benefit4Title': 'Multi-establiment',
    'local.benefit4Desc': 'Gestiona totes les teves botigues de la zona des d\'un únic panell.',
    'local.benefit5Title': 'Funciona offline',
    'local.benefit5Desc': 'Ven amb o sense internet; se sincronitza al tornar la connexió.',
    'local.benefit6Title': 'Cobertura local',
    'local.benefit6Desc': 'Equip tècnic a la teva província per a instal·lació i manteniment.',
    'local.sectorsTitle': 'Sectors que cobrim a',
    'local.sector1': 'Hostaleria i restaurants',
    'local.sector2': 'Retail i moda',
    'local.sector3': 'Alimentació',
    'local.sector4': 'Bellesa i perruqueries',
    'local.zonesTitle': 'Zones d\'instal·lació',
    'local.zonesDesc1': 'No veus la teva zona? Cobrim tota la província de',
    'local.zonesDesc2': 'i voltants. Truca\'ns i et confirmem disponibilitat.',
    'local.ctaTitle1': 'Parlem del teu negoci a',
    'local.ctaTitle2': '?',
    'local.ctaSubtitle': 'Sol·licita la teva demo gratuïta i un expert local et truca.',
    'local.ctaBtn': 'Sol·licita demo',

    'cookie.text': 'Utilitzem cookies per analitzar el tràfic.',
    'cookie.accept': 'Acceptar',
    'cookie.policy': 'Política de cookies',
  },
    'form.required': 'Aquest camp és obligatori',
    'form.email': 'Revisa el correu: sembla incomplet',
    'form.phone': 'Escriu un telèfon vàlid (mínim 7 dígits)',
    'form.notes': 'Màxim 1000 caràcters',
    'data.loadError': 'No hem pogut carregar això.',
    'data.retry': 'Torna-ho a provar',
  FR: {
    // Espace techniciens
    'footer.technicians': 'Espace techniciens',
    'technicians.title': 'Espace techniciens',
    'technicians.subtitle': "Accès réservé à l'équipe technique de SmartPOS.",
    'technicians.email': 'E-mail',
    'technicians.password': 'Mot de passe',
    'technicians.login': 'Se connecter',
    'technicians.loggingIn': 'Connexion...',
    'technicians.google': 'Continuer avec Google',
    'technicians.invalid': 'Identifiants invalides. Vérifiez et réessayez.',
    'technicians.welcome': 'Bonjour',
    'technicians.accessTitle': 'Configurateur de matériel',
    'technicians.accessDesc': 'Accédez au configurateur PC pour assembler des équipements sur mesure pour vos clients.',
    'technicians.openConfig': 'Ouvrir le configurateur',
    'technicians.logout': 'Se déconnecter',
    'technicians.noPermission': 'Accès refusé',
    'technicians.noPermissionDesc': "Ce compte n'a pas accès à l'espace techniciens.",
    // Page Qui sommes-nous
    'about.eyebrow': 'À propos de SmartPOS',
    'about.title1': 'Qui',
    'about.title2': 'sommes-nous',
    'about.desc1': 'Chez SmartPOS, nous développons des solutions technologiques qui aident les entreprises à digitaliser, simplifier et optimiser leur gestion.',
    'about.desc2': 'Nous combinons innovation, technologie et service personnalisé pour offrir des solutions adaptées aux besoins de chaque client.',
    'about.mission.title': 'Mission',
    'about.mission.claim': 'Simplifier la gestion. Dynamiser les entreprises.',
    'about.mission.text': 'Proposer des solutions technologiques innovantes, simples et adaptées qui aident nos clients à gérer leur entreprise de façon plus efficace, connectée et rentable.',
    'about.vision.title': 'Vision',
    'about.vision.claim': 'Transformer la façon de faire des affaires.',
    'about.vision.text': 'Être une référence en solutions technologiques pour les entreprises, en accompagnant leur transformation digitale dans un environnement de plus en plus connecté et dynamique.',
    'about.values.title': 'Valeurs',
    'about.values.subtitle': 'Les principes qui guident notre travail chaque jour.',
    'about.values.innovation.title': 'Innovation',
    'about.values.innovation.text': "Nous regardons vers l'avenir pour transformer la technologie en opportunités réelles. Nous étudions et adoptons les dernières tendances, comme l'intelligence artificielle, pour créer des solutions qui font la différence.",
    'about.values.commitment.title': 'Engagement',
    'about.values.commitment.text': 'Nous nous impliquons dans chaque projet et chaque relation avec nos clients. Nous accompagnons chaque mise en œuvre du début à la fin, avec dévouement et responsabilité dans chaque détail.',
    'about.values.closeness.title': 'Proximité',
    'about.values.closeness.text': 'Derrière chaque entreprise, il y a des personnes. Nous écoutons, comprenons et accompagnons nos clients à chaque étape, en construisant des relations de confiance et de proximité.',
    'about.values.adaptability.title': 'Adaptabilité',
    'about.values.adaptability.text': "Chaque entreprise est unique. Nos solutions doivent l'être aussi. Nous configurons chaque mise en œuvre sur mesure pour répondre aux besoins spécifiques de chaque secteur.",
    'about.values.evolution.title': 'Évolution',
    'about.values.evolution.text': 'Nous apprenons, nous nous améliorons et nous avançons en continu pour toujours offrir plus. Nous intégrons constamment de nouvelles technologies et fonctionnalités pour que nos clients grandissent sans limites.',
    'about.cta.title': 'Parlons de votre entreprise ?',
    'about.cta.text': 'Découvrez comment nos solutions peuvent vous aider à grandir. Sans engagement.',
    'about.cta.demo': 'Demander une démo',
    'about.cta.contact': 'Nous contacter',

    // Textes partagés des sections
    'faq.sectionTitle': 'Questions fréquentes',
    'indicator.inicio': 'Accueil',
    'indicator.sectores': 'Secteurs',
    'indicator.comoFunciona': 'Comment ça marche',
    'indicator.solucion': 'La solution',
    'indicator.verifactu': 'VeriFactu',
    'indicator.tpv': 'TPV pour entreprise',
    'indicator.faq': 'Questions fréquentes',
    'ia.chart.title': 'Prévision de la demande hebdomadaire',
    'ia.chart.subtitle': 'IA analysant les ventes réelles vs. la prévision',
    'ia.chart.real': 'Réel',
    'ia.chart.prediction': 'Prévision IA',
    'aria.clientCarousel': 'Carrousel de clients SmartPOS',
    'aria.playVideo': 'Lire la vidéo',
    'aria.mute': 'Activer le son',
    'aria.unmute': 'Couper le son',
    'aria.fullscreen': 'Plein écran',
    'ia.day.lun': 'Lun',
    'ia.day.mar': 'Mar',
    'ia.day.mie': 'Mer',
    'ia.day.jue': 'Jeu',
    'ia.day.vie': 'Ven',
    'ia.day.sab': 'Sam',
    'ia.day.dom': 'Dim',
    'ia.chart.insight': 'Samedi dépassera vendredi de 15 %. Préparez 40 portions supplémentaires et renforcez l\'équipe à 14h30.',

    'home.manifesto1.title': "L'avenir du commerce physique ne dépend plus de la technologie. Il dépend de la façon dont nous la connectons.",
    'home.manifesto2.eyebrow': 'La solution',
    'home.manifesto2.title': 'Smartpos transforme votre entreprise à 100%. Nous unissons IA, TPV, ERP, CRM, e-commerce, automatisation et données dans un seul écosystème intelligent.',
    'home.manifesto3.eyebrow': 'Le résultat',
    'home.manifesto3.title': "Avec Smartpos, les entreprises réduisent les coûts, augmentent les ventes, automatisent les processus et prennent des décisions avec une précision chirurgicale.",

    'sectors.eyebrow': 'Secteurs',
    'sectors.title1': 'Adapté à votre',
    'sectors.titleHighlight': 'type de commerce',
    'sectors.desc': "Il n'existe pas de solution unique. Notre système se configure aux besoins exacts de votre secteur.",
    'sectors.hospitality.name': 'Hôtellerie',
    'sectors.hospitality.headline': "Plus de tables servies, moins d'attente.",
    'sectors.hospitality.desc': 'Des restaurants aux discothèques. Commandes à table, menu digital, cuisine connectée et clôture de caisse automatique.',
    'sectors.hospitality.tags': 'Restaurants|Bars|Fast Food|Disco / Pub|Glaciers',
    'sectors.hospitality.metric': '30% plus rapide au service',
    'sectors.retail.name': 'Retail',
    'sectors.retail.headline': 'Vendez plus. Gérez moins.',
    'sectors.retail.desc': "Contrôle des stocks en temps réel, fidélisation client et ventes omnicanal depuis un seul panneau.",
    'sectors.retail.tags': 'Boutiques de vêtements|Chaussures|Accessoires|Supermarchés|Commerces',
    'sectors.retail.metric': '25% de réduction des temps de caisse',
    'sectors.food.name': 'Alimentation',
    'sectors.food.headline': 'Précision dans chaque gramme.',
    'sectors.food.desc': 'Intégration avec balances, gestion des pertes, traçabilité par lot et conformité réglementaire automatique.',
    'sectors.food.tags': 'Boulangeries|Pâtisseries|Boucheries|Fruitiers|Épiceries',
    'sectors.food.metric': "40% moins d'erreurs de stock",
    'sectors.beauty.name': 'Beauté',
    'sectors.beauty.headline': 'Votre agenda plein, votre caisse ordonnée.',
    'sectors.beauty.desc': 'Réservations en ligne 24/7, gestion des rendez-vous, suivi des commissions et carte de services digitale.',
    'sectors.beauty.tags': "Salons de coiffure|Centres d'esthétique|Spa|Nail Studio|Barbier",
    'sectors.beauty.metric': '60% plus de réservations en ligne',
    'sectors.metricLabel': 'Moyenne des clients SmartPOS dans ce secteur',
    'sectors.demo': 'Demander une démo',
    'sectors.prices': 'Voir les prix',

    'ia.eyebrow': 'IA Intégrée',
    'ia.title1': 'Intelligence artificielle',
    'ia.title2': 'intégrée dans votre entreprise.',
    'ia.desc': "Il ne s'agit pas d'ajouter de l'IA, mais de l'intégrer là où elle transforme vraiment : dans votre TPV, votre inventaire et vos décisions. SmartPOS convertit vos données opérationnelles en intelligence actionnable.",
    'ia.live': '● en direct',
    'ia.subtitle': 'Restaurante La Rambla · service du déjeuner',
    'ia.quote': "Nous sommes 18,85% au-dessus de l'objectif. Renforcez le poste de cuisine à 14:30 et préparez 40 portions supplémentaires du menu du jour.",
    'ia.kpi.sales': "Ventes du jour",
    'ia.kpi.forecast': 'Prévision demain',
    'ia.kpi.ticket': 'Ticket moyen',
    'ia.kpi.peak': 'Heure de pointe prévue',
    'ia.kpi.vsTarget': '+18,8% vs objectif',
    'ia.kpi.vsToday': "+12% vs aujourd'hui",
    'ia.kpi.desserts': '+1,50€ desserts',
    'ia.kpi.capacity': '+34% affluence',
    'ia.starDish': 'Plat vedette du jour',
    'ia.starDishDemand': '+34% demande',
    'ia.starDishName': 'Paella aux fruits de mer',
    'ia.starDishRec': 'Augmentez le prix de 1,50€ : la demande le permet. Marge estimée +38€/jour.',
    'ia.alertStock': 'Stock critique : crevette, citron et bière artisanale',
    'ia.alertWaste': 'Pertes prévues : 6 desserts expirent dans 48h — lancez 2x1',

    'verifactu.eyebrow': 'VeriFactu',
    'verifactu.title': 'Conformité fiscale automatique',
    'verifactu.desc': "Signature et envoi automatiques des tickets à l'Agence Fiscale, sans changer votre façon de travailler.",
    'verifactu.f1': 'Signature électronique automatique sur chaque ticket',
    'verifactu.f2': "Envoi en temps réel à l'Agence Fiscale",
    'verifactu.f3': "Conforme à la réglementation dans toute l'Espagne",
    'verifactu.f4': 'Mises à jour réglementaires incluses',
    'verifactu.f5': 'Aucun changement à votre flux de travail habituel',
    'verifactu.viewSolution': 'Voir la solution complète',
    'verifactu.startNow': 'Commencer maintenant',
    'verifactu.monitor': 'VeriFactu Monitor',
    'verifactu.systemActive': 'Système actif',
    'verifactu.live': 'EN DIRECT',
    'verifactu.compliant': '100% conforme à la réglementation espagnole',
    'verifactu.log1': 'Ticket #4521 signé',
    'verifactu.log2': "Envoyé à l'AEAT",
    'verifactu.log3': 'Ticket #4520 signé',
    'verifactu.log4': "Envoyé à l'AEAT",
    'verifactu.log5': 'Clôture de caisse enregistrée',

    'seo.eyebrow': 'TPV pour entreprise',
    'seo.title1': 'Le',
    'seo.titleHighlight': 'TPV pour votre entreprise',
    'seo.titleEnd': ', tout intégré',
    'seo.desc': 'Logiciel TPV cloud, matériel, tiroirs intelligents, kiosques, menu digital et paiements. Un écosystème pour vendre plus.',
    'seo.whatTitle': "Qu'est-ce qu'un TPV et pourquoi votre entreprise en a-t-elle besoin ?",
    'seo.whatText': "Un TPV (Terminal Point de Vente) gère les ventes de votre entreprise : encaissement, stock, rapports, employés et multi-boutiques. Un bon système TPV automatise et analyse pour croître. SmartPOS inclut logiciel TPV cloud, matériel tactile, tiroirs CashDro, kiosques en libre-service, menu digital et commandes en ligne et moyens de paiement intégrés.",
    'seo.typesTitle': 'TPV pour chaque type de commerce',
    'seo.type1.label': 'TPV pour hôtellerie et restaurants',
    'seo.type1.desc': 'Tables, commandes, cuisine, menu digital et commandes en ligne.',
    'seo.type2.label': 'TPV pour retail et boutiques',
    'seo.type2.desc': 'Stock, codes-barres, fournisseurs et marges en temps réel.',
    'seo.type3.label': 'TPV pour alimentation',
    'seo.type3.desc': 'Poids, lots, dates de péremption et sync multi-succursales.',
    'seo.type4.label': 'TPV pour beauté et salons de coiffure',
    'seo.type4.desc': 'Agenda, rendez-vous, abonnements et commissions par employé.',
    'seo.whyTitle': 'Pourquoi choisir SmartPOS comme TPV ?',
    'seo.reason1': 'Tout intégré : logiciel, matériel, paiements, kiosques et menu digital',
    'seo.reason2': 'Conformité VeriFactu prête pour 2027',
    'seo.reason3': 'Multi-boutiques : gérez toutes vos boutiques depuis un seul panneau',
    'seo.reason4': 'Réponse en moins de 24h avec équipe locale à Barcelone et Madrid',
    'seo.reason5': 'Fonctionne sans internet avec synchronisation automatique',
    'seo.reason6': 'Démo gratuite et sans engagement',
    'seo.cta': 'Essayer le TPV gratuitement',


    'faq.eyebrow': 'Questions fréquentes',
    'faq.title1': 'Nous résolvons vos',
    'faq.titleHighlight': 'doutes',
    'faq.desc': 'Tout ce que vous devez savoir avant de franchir le pas',
    'faq.ctaDesc': 'Vous ne trouvez pas la réponse à votre question ?',
    'faq.ctaBtn': 'Parler à un expert',
    'faq.cat.install': 'Installation',
    'faq.cat.support': 'Support technique',
    'faq.cat.verifactu': 'VeriFactu',
    'faq.cat.integration': 'Intégration',
    'faq.q1': "Combien de temps prend l'installation du système ?",
    'faq.a1': "L'installation de HIOPOS Cloud est rapide et simple. Dans la plupart des cas, votre entreprise sera opérationnelle en moins de 24 heures. Notre équipe technique configure le logiciel, le matériel tactile et les appareils de paiement pour que vous n'ayez qu'à commencer à vendre.",
    'faq.q2': 'Dois-je changer tout mon matériel actuel ?',
    'faq.a2': "Non. HIOPOS Cloud fonctionne sur plusieurs appareils : TPV tactile, tablettes, smartphones et même votre matériel compatible actuel. Nous évaluons votre équipement et vous recommandons la solution la plus rentable, sans changer ce qui fonctionne déjà.",
    'faq.q3': 'Dans quels délais le support technique répond-il ?',
    'faq.a3': "Nous répondons en moins de 24 heures. Vous pouvez nous contacter par téléphone, email ou chat en direct et notre équipe de support technique vous répond dans les meilleurs délais, avec résolution d'incidents garantie.",
    'faq.q4': "Que se passe-t-il si la connexion internet tombe ?",
    'faq.a4': "Le système continue de fonctionner. HIOPOS Cloud est un TPV hybride qui fonctionne avec ou sans connexion : il enregistre toutes les ventes localement et se synchronise automatiquement avec le cloud lorsque la connexion est rétablie, sans perdre aucune donnée.",
    'faq.q5': 'Le système est-il adapté à la réglementation VeriFactu ?',
    'faq.a5': "Oui. HIOPOS Cloud est entièrement conforme à la réglementation VeriFactu, obligatoire avant le 1er janvier 2027. Le système génère et envoie automatiquement les factures simplifiées à l'AEAT, sans que vous ayez à faire quoi que ce soit manuellement.",
    'faq.q6': 'Dois-je faire quelque chose pour être en règle avec le fisc ?',
    'faq.a6': "Non. L'intégration avec VeriFactu est automatique et transparente. Chaque fois que vous émettez un ticket, le système l'enregistre, le signe et l'envoie au fisc pour vous. Vous n'avez qu'à vendre ; nous nous occupons de la conformité fiscale.",
    'faq.q7': 'Puis-je intégrer le TPV avec mon e-commerce et mes commandes en ligne ?',
    'faq.a7': "Bien sûr. L'écosystème SmartPOS est omnicanal : il intègre TPV, menu digital, commandes en ligne, livraison, takeaway et réservations dans un seul système. Tout synchronisé en temps réel, avec stock et ventes centralisés.",
    'faq.q8': 'Fonctionne-t-il avec plusieurs établissements ?',
    'faq.a8': "Oui. HIOPOS Cloud est multi-établissements et multi-terminaux. Gérez toutes vos boutiques depuis un seul panneau, avec stock, ventes et rapports consolidés en temps réel, quel que soit le nombre d'établissements.",

    'trust.eyebrow': 'Témoignages',
    'trust.title1': 'Ils ont déjà',
    'trust.titleHighlight': 'grandi',
    'trust.titleEnd': 'avec HIOPOS',
    'trust.desc': '+500 entreprises en Espagne font confiance aux solutions HIOPOS',
    'trust.stat1': 'Entreprises actives',
    'trust.stat2': 'Transactions gérées',
    'trust.stat3': 'Disponibilité du système',
    'trust.stat4': 'Évaluation moyenne',
    'trust.logoStrip': 'ENTREPRISES ET ENTITÉS QUI FONT CONFIANCE AUX SOLUTIONS HIOPOS',

    'success.label': 'Témoignages · +500 entreprises font confiance aux solutions HIOPOS',

    'chat.greeting': "Bonjour ! 👋 Je suis Smarty!, l'assistant virtuel de Smartpos. Parlez-moi de votre entreprise et je vous aide à trouver la solution idéale. Dans quel secteur opérez-vous ?",
    'chat.name': 'Smarty',
    'chat.online': 'En ligne',
    'chat.mute': 'Couper la voix',
    'chat.unmute': 'Activer la voix',
    'chat.placeholder': 'Écrivez votre message...',
    'chat.assistant': 'Assistant IA SmartPOS',
    'chat.suggestion1': 'Quelle solution est idéale pour un restaurant ?',
    'chat.suggestion2': 'Comment fonctionne CashDro ?',
    'chat.suggestion3': "Qu'inclut la démo gratuite ?",
    'chat.errorReply': "Désolé, je n'ai pas pu répondre pour le moment. Pouvez-vous reformuler ?",
    'chat.errorTech': 'Oups, il y a eu un problème technique. Vous pouvez nous appeler au +34 936 302 521 ou demander la démo gratuite.',

    'demo.step': 'Étape',
    'demo.of': 'sur',
    'demo.progressLabel': 'Progression du formulaire',
    'demo.s0Title': 'Dans quel secteur opérez-vous ?',
    'demo.s0Subtitle': 'Commençons par apprendre à nous connaître',
    'demo.s1Title': "Combien d'établissements avez-vous ?",
    'demo.s1Subtitle': 'Nous adaptons la solution à votre taille',
    'demo.s2Title': 'De quoi avez-vous besoin ?',
    'demo.s2Subtitle': 'Choisissez tout ce qui vous intéresse',
    'demo.s3Title': "Un expert vous appelle aujourd'hui",
    'demo.s3Subtitle': 'Sans engagement · Réponse en moins de 24h ouvrées',
    'demo.name': 'Nom',
    'demo.namePlaceholder': 'Votre nom',
    'demo.phone': 'Téléphone *',
    'demo.phonePlaceholder': '+34 600 000 000',
    'demo.email': 'Email',
    'demo.emailPlaceholder': 'vous@entreprise.com',
    'demo.company': 'Entreprise / Établissement',
    'demo.companyPlaceholder': 'Nom du commerce',
    'demo.province': 'Province',
    'demo.provincePlaceholder': 'Barcelona, Madrid...',
    'demo.notes': 'Observations',
    'demo.notesPlaceholder': 'Dites-nous ce dont vous avez besoin (optionnel)',
    'demo.back': 'Retour',
    'demo.continue': 'Continuer',
    'demo.submit': 'Je veux ma démo',
    'demo.submitting': 'Envoi...',
    'demo.reassurance1': 'RGPD',
    'demo.reassurance2': 'Réponse 24h ouvrées',
    'demo.reassurance3': '100% gratuit',
    'demo.successTitle1': 'Parfait,',
    'demo.successTitle2': ' !',
    'demo.successDesc1': 'Un expert vous appellera au',
    'demo.successDesc2': 'en moins de 24h ouvrées.',
    'demo.successItem1': 'Démo personnalisée',
    'demo.successItem2': 'Prix sur mesure',
    'demo.successItem3': 'Sans engagement',
    'demo.successCall': 'Préférez-vous appeler ?',
    'demo.backHome': "Retour à l'accueil",
    'demo.errorDuplicate': 'Nous avons déjà reçu votre demande. Un expert vous contactera très bientôt.',
    'demo.errorGeneric': 'Envoi impossible. Réessayez ou appelez-nous au 936 302 521.',

    'local.coverage': 'Couverture à',
    'local.requestDemo': 'Demander une démo gratuite',
    'local.whyTitle': 'Pourquoi choisir SmartPOS à',
    'local.benefit1Title': 'Installation en 24h',
    'local.benefit1Desc': 'Votre entreprise opérationnelle en moins de 24 heures avec configuration incluse.',
    'local.benefit2Title': 'Réponse en moins de 24h',
    'local.benefit2Desc': "Support technique local tous les jours de l'année, nous répondons en moins de 24 heures.",
    'local.benefit3Title': 'Conforme VeriFactu',
    'local.benefit3Desc': "Factures simplifiées envoyées automatiquement à l'AEAT.",
    'local.benefit4Title': 'Multi-établissements',
    'local.benefit4Desc': 'Gérez toutes vos boutiques de la zone depuis un seul panneau.',
    'local.benefit5Title': 'Fonctionne hors ligne',
    'local.benefit5Desc': 'Vendez avec ou sans internet ; se synchronise au retour de la connexion.',
    'local.benefit6Title': 'Couverture locale',
    'local.benefit6Desc': "Équipe technique dans votre province pour l'installation et la maintenance.",
    'local.sectorsTitle': 'Secteurs que nous couvrons à',
    'local.sector1': 'Hôtellerie et restaurants',
    'local.sector2': 'Retail et mode',
    'local.sector3': 'Alimentation',
    'local.sector4': 'Beauté et salons de coiffure',
    'local.zonesTitle': "Zones d'installation",
    'local.zonesDesc1': "Vous ne voyez pas votre zone ? Nous couvrons toute la province de",
    'local.zonesDesc2': 'et alentours. Appelez-nous et nous confirmons la disponibilité.',
    'local.ctaTitle1': 'Parlons de votre entreprise à',
    'local.ctaTitle2': ' ?',
    'local.ctaSubtitle': 'Demandez votre démo gratuite et un expert local vous appelle.',
    'local.ctaBtn': 'Demander une démo',

    'cookie.text': 'Nous utilisons des cookies pour analyser le trafic.',
    'cookie.accept': 'Accepter',
    'cookie.policy': 'Politique de cookies',
    'form.required': 'Ce champ est obligatoire',
    'form.email': "Vérifiez l'email : il semble incomplet",
    'form.phone': 'Saisissez un numéro de téléphone valide (au moins 7 chiffres)',
    'form.notes': 'Maximum 1000 caractères',
    'data.loadError': "Nous n'avons pas pu charger ce contenu.",
    'data.retry': 'Réessayer',
  },
};